var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window-scroll-detector',[_c('v-app',[_c('header-app-bar'),_vm._v(" "),_c('v-main',[_c('router-view')],1),_vm._v(" "),_c('error-snackbar'),_vm._v(" "),_c('success-snackbar'),_vm._v(" "),_c('version')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }